import { Routes } from '@angular/router';
import { LettersListComponent } from './features/letters/letters-list/letters-list.component';
import { LettersReplyComponent } from './features/letters/letters-reply/letters-reply.component';
import { LettersDetailsComponent } from './features/letters/letters-details/letters-details.component';
import { LettersUploadComponent } from './features/letters/letters-upload/letters-upload.component';
import { SignInComponent } from './features/auth/sign-in/sign-in.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { UsersListComponent } from './features/users/users-list/users-list.component';
import { UsersCreateComponent } from './features/users/users-create/users-create.component';
import { UsersEditComponent } from './features/users/users-edit/users-edit.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RoleGuard } from './core/guards/role.guard';
import { UserRole } from './shared/models/auth.model';
import { AccountSettingsComponent } from './features/account-settings/account-settings.component';
import { RoutingSlipCreateComponent } from './features/routing-slips/routing-slip-create/routing-slip-create.component';
import { RoutingSlipListComponent } from './features/routing-slips/routing-slip-list/routing-slip-list.component';
import { RoutingSlipDetailsComponent } from './features/routing-slips/routing-slip-details/routing-slip-details.component';
import { RoutingSlipEditComponent } from './features/routing-slips/routing-slip-edit/routing-slip-edit.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

export const routes: Routes = [
  // Public routes (no authentication required)
  { path: '', component: SignInComponent }, // Default route
  { path: 'sign-in', component: SignInComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },

  // Protected routes (authentication required)
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'letters',
    component: LettersListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'letters/reply',
    component: LettersReplyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'letters/details',
    component: LettersDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'letters/upload',
    component: LettersUploadComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'letters/edit',
    component: LettersUploadComponent,
    canActivate: [AuthGuard],
  },

  // Admin-only routes
  {
    path: 'users',
    component: UsersListComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.ADMIN] },
  },
  {
    path: 'users/create',
    component: UsersCreateComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.ADMIN] },
  },
  {
    path: 'users/edit',
    component: UsersEditComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.ADMIN] },
  },
  {
    path: 'users/details',
    component: UsersListComponent, // TODO: Replace with actual details component
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.ADMIN] },
  },
  {
    path: 'routing-slip',
    component: RoutingSlipListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'routing-slip/create',
    component: RoutingSlipCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'routing-slip-details',
    component: RoutingSlipDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'routing-slip-edit',
    component: RoutingSlipEditComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.MANAGER, UserRole.ADMIN] },
  },
  {
    path: 'account',
    component: AccountSettingsComponent,
    canActivate: [AuthGuard, RoleGuard],
  },

  // Catch all route - 404 page
  { path: '**', component: PageNotFoundComponent },
];
